import { Component, OnInit, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from "@angular/router";

import { Eventos, EventService } from '../shared';
import { LanguageService } from '../../core/language-resource/language.service';
import { LanguagePipe } from '../../core/language-resource/language.pipe';

@Component({
  moduleId: module.id,
  selector: 'bp-event-callendar',
  templateUrl: 'event-calendar.component.html'
})

export class EventCalendarComponent implements OnInit, OnDestroy {
  private dbResetSubscription: Subscription;

  @Input() contentId: number;

  local: string;
  events: any[];
  filteredEvents: any;
  header: any;
  dialogVisible: boolean;
  event: Eventos;

  constructor(
    private eventService: EventService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private languageService: LanguageService,
    private languagePipe: LanguagePipe,
  ) { }

  getEvents() {
    this.events = [];

    this.eventService.getEvents(this.contentId).subscribe(events => {
      this.events = this.filteredEvents = events;
    });
  }

  ngOnInit(): void {
    if (this.languageService.currentLang == "1") {
      this.local = "sr";
    }
    else {
      this.local = "sr-cyrl";

    }

    this.header = {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay'
    };
    this.getEvents();
    
    this.dbResetSubscription = this.eventService.onDbReset
      .subscribe(() => this.getEvents());
  }
  ngOnDestroy(): void {
    this.dbResetSubscription.unsubscribe();
  }

  handleDayClick(event) {
    //this.event = new Eventos();
    //this.event.start = event.date.format();
    //this.dialogVisible = true;

    ////trigger detection manually as somehow only moving the mouse quickly after click triggers the automatic detection
    //this.cd.detectChanges();
  }

  handleEventClick(e) {
    // this.router.navigate([e.calEvent.id],  {relativeTo: this.activatedRoute});
     this.event = new Eventos();
     this.event.title = e.calEvent.title;

     let start = e.calEvent.start;
     let end = e.calEvent.end;
     if (e.view.name === 'month') {
       start.stripTime();
     }

     if (end) {
       end.stripTime();
       this.event.end = end.format('DD.MM.YYYY.');
     }

     this.event.id = e.calEvent.id;
     this.event.start = start.format('DD.MM.YYYY.');
     this.event.allDay = e.calEvent.allDay;
     this.event.desc = e.calEvent.desc;
     this.dialogVisible = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/events/event-calendar/event-calendar.component.ts